import { chooseService, getCameraFromList } from '../utils';
import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { getTimeline } from "../store/timeline/actions";
import { ApplicationState } from "../store";
import { LayoutState } from "../store/layouts/types";
import { StripType } from "../utils";
import { RouterState } from "connected-react-router";
import { BrowseState } from "../store/browse/types";
import { Routes } from '../types';
import { APIState } from "../store/API/types";

const {CONFIG} = window;


export const getMaxDuration = () => {
  //@ts-ignore
  const timelineDurations = Object.values(CONFIG.timelines).map(timeline => timeline.duration * 1000);

  return Math.max.apply(Math, timelineDurations)   // take max value from config of duration
};

export const getStartTime = (time: number) => {
  const startPoint = time - getMaxDuration() / 2;
  return startPoint - (startPoint % 3600000);  // means that starttime always will be round numbers
};

export const getEndTimeSimple = (time: number) => {
  let endPoint = time + getMaxDuration() / 2;
  endPoint = endPoint + (3600000 - (endPoint % 3600000));
  return Math.min(endPoint, Date.now())
};

export const isInsideTimeBounds = (strips: any, time: number) => {
  const filteredStrips = strips
    .filter(({low, high, type}: StripType) => (time >= low && time <= high && type !== 5));

  return Boolean(filteredStrips.length)
};

export const getMinVal = (strips: StripType[]) => {
  const lows = strips.map(({low}: StripType) => low);

  return lows.length ? Math.min.apply(null, lows) : null;
};

export const getMaxVal = (strips: StripType[]) => {
  const highs = strips.map(({high}: StripType) => high);

  return highs.length ? Math.max.apply(null, highs) : null;
};


const useGettimelineForPane = (time: number) => {
  const dispatch = useDispatch();
  const {browsePanes} = useSelector<ApplicationState, BrowseState>(state => state.browse);
  const {checkedPane} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
  const {location} = useSelector<ApplicationState, RouterState>(state => state.router);
  const {cameras} = useSelector<ApplicationState, APIState>(state => state.API)


  const initedFirst = location.pathname === Routes.bookmarks && browsePanes[0] && browsePanes[0].success;
  const initedSecond = location.pathname === Routes.bookmarks && browsePanes[1] && browsePanes[1].success;

  const doFetchTimeline = (pane: number) => {
    const timestrips = browsePanes[pane] && browsePanes[pane].timestrips ? browsePanes[pane].timestrips : null;

    if (time > Date.now()) return false;
    if (!timestrips) return true;

    const startTime = getStartTime(time);
    const endTime = getEndTimeSimple(time);

    if (!isInsideTimeBounds(timestrips, startTime)) return true;
    if (!isInsideTimeBounds(timestrips, Math.min(endTime, Date.now() - 60000))) return true; // update time line every 1 min
  };

  const doGetOcularisTimeLine = (strips: any, pane: number) => {
    let startTime, endTime: number;
    startTime = getStartTime(time);
    endTime = getEndTimeSimple(time);
    const continuation_id = browsePanes[pane].continuation_id ? browsePanes[pane].continuation_id : null;
    startGetTimeLine(strips, pane, startTime, endTime, continuation_id);
  };

  const doGetCayugaTimeLine = (strips: any, pane: number) => {
    const cam = getCameraFromList(cameras, browsePanes?.[pane]?.id);
    if (cam) {
      let startTime, endTime: number;
      startTime = getStartTime(time);
      endTime = getEndTimeSimple(time);
      const continuation_id = browsePanes[pane].continuation_id ? browsePanes[pane].continuation_id : null;
      startGetTimeLine(strips, pane, startTime, endTime, continuation_id);
    }
  }

  const startGetTimeLine = (strips: any, pane: number, startTime: number, endTime: number, continuation_id: string | null) => {
    if (strips) {
      const min = getMinVal(strips);
      const max = getMaxVal(strips);
      if (min && startTime < min) endTime = min;
      if (max && endTime > max) startTime = max;
    }
    dispatch(getTimeline(pane, startTime, endTime, continuation_id));
  }

  // *********** uses only for browsemode **********************
  useEffect(() => {
    location.pathname === Routes.browse && Object.entries(browsePanes)
      .filter(([pane, cam]: any) => cam && pane <= 1)
      .map(([pane, {timestrips, timeStripFetch, success}]: any) => {
        if (success && !timeStripFetch && doFetchTimeline(pane)) {
          chooseService(
            () => doGetOcularisTimeLine(timestrips, pane),
            () => doGetCayugaTimeLine(timestrips, pane)
          );
        }
      });
  }, [time, checkedPane]);

  useEffect(() => {
    const updateTimeLineTimer = setInterval(() => {
      location.pathname === Routes.browse && Object.entries(browsePanes)
        .filter(([pane, cam]: any) => cam && pane <= 1)
        .map(([pane, {timestrips, timeStripFetch, success}]: any) => {
          if (!timeStripFetch && typeof (success) !== 'undefined') {
            chooseService(
              () => doGetOcularisTimeLine(timestrips, pane),
              () => doGetCayugaTimeLine(timestrips, pane)
            );
          }
        });
    }, 5000);
    return () => {
      clearInterval(updateTimeLineTimer);
    }
  });


  // ************uses only for bookmarks *******************
  useEffect(() => {
    location.pathname === Routes.bookmarks && Object.entries(browsePanes)
      .filter(([pane, cam]: any) => cam && pane <= 1)
      .map(([pane, {timestrips, timeStripFetch, success}]: any) => {
        if (success && !timeStripFetch && browsePanes[pane].bookmarks) {
          const startTime = browsePanes[pane].bookmarks.startTime;
          const endTime = browsePanes[pane].bookmarks.endTime;

          dispatch(getTimeline(pane, startTime, endTime, null));
        }
      });
  }, [initedFirst, initedSecond])
};

export default useGettimelineForPane;